// Shared parsing/validation for the editable line item fields. Persisted values
// may still arrive as strings from older payloads, so rounding accepts either.

import { type PriceBookItemType } from '@/api/types/priceBookTypes'
import { type LineItemDetails } from '@/models/line-item'

/** Field edits emitted by a line item card for the parent form to apply. */
export interface LineItemFieldChanges {
  name?: string
  priceBookItemId?: string | null
  rate?: number | null
  quantity?: number | null
  /** The type picked for a custom item. */
  type?: PriceBookItemType | null
  /** Replaces all of the item's details. */
  details?: LineItemDetails
}

function roundToFiveDecimals(value: number | string | null) {
  if (value == null || value === '') return null
  return Math.abs(
    Math.round((typeof value === 'string' ? parseFloat(value) : value) * 100000) / 100000,
  )
}

export function roundRateInput(value: number | string | null) {
  return roundToFiveDecimals(value)
}

export function roundQuantityInput(value: number | string | null) {
  return roundToFiveDecimals(value)
}

/** Emptiness is handled by `required`; this only rejects non-positive values. */
export function quantityRule(value: number | null) {
  return value !== null && value <= 0 && 'Quantity must be greater than 0'
}
